import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const EkoBillingFooter = () => {
  const path = useLocation().pathname;
  const [infoVisible, setInfoVisible] = useState<boolean>();

  useEffect(() => {
    if (path === "/login") {
      setInfoVisible(false);
    } else {
      setInfoVisible(true);
    }
  }, [path]);
  return (
    <>
      <footer className="footer">
        {infoVisible ? (
          <div id="info">
            <div className="container">
              <div className="row">
                <div className="col-4">
                  <h3 className="widgettitle">Więcej</h3>
                  <ul id="menu-stopka" className="menu">
                    <li>
                      <a
                        target=""
                        rel="noopener noreferrer"
                        href="https://mzgk.com.pl//"
                        role="link"
                      >
                        Witryna MZGK Bolesławiec
                      </a>
                    </li>
                    <li>
                      <a
                        target=""
                        rel="noopener noreferrer"
                        href="http://www.js.boleslawiec.bip-gov.pl/public"
                        role="link"
                      >
                        Biuletyn Informacji Publicznej
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <div className="col-4">
                  <h3 className="widgettitle">Godziny pracy</h3>{" "}
                  <div className="textwidget">
                    <p>
                      <strong>Biuro:</strong>
                      <br />
                      Poniedziałek – Piątek:&nbsp;<strong>7:00–15:00</strong>
                      <br />
                      <strong>Kasa:</strong>
                      <br />
                      Poniedziałek – Piątek:&nbsp;<strong>7:00–14:30</strong>
                    </p>
                    <p>
                      <strong>PSZOK-i:</strong>
                      <br />
                      <strong>ul. Łukasiewicza 4</strong>&nbsp;oraz&nbsp;
                      <strong>Al. Niepodległości 253</strong>
                      <br />
                      Poniedziałek – Piątek:&nbsp;<strong>7:00 – 15:00</strong>
                      <br />
                      Sobota:&nbsp;<strong>10:00 – 16:00</strong>
                    </p>
                  </div>
                </div> */}
                <div className="col-4">
                  <h3 className="widgettitle">
                    Miejski Zakład Gospodarki Komunalnej Sp. z o.o. w Bolesławcu
                  </h3>
                  <div className="textwidget">
                    <p>
                      ul. St.Staszica 6,
                      <br />
                      59-700 Bolesławiec
                      <br />
                      tel./faks:{" "}
                      <a
                        href="tel:+757346271"
                        target=""
                        rel="noreferrer noopener"
                        role="link"
                      >
                        +75 734 62 71
                      </a>{" "}
                      /{" "}
                      <a
                        href="tel:+727400200"
                        target=""
                        rel="noreferrer noopener"
                        role="link"
                      >
                        727 400 200
                      </a>
                      <br />
                      e-mail:{" "}
                      <a href="mailto:mzgk@mzgk.com.pl" role="link">
                        mzgk@mzgk.com.pl
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <div id="socket" className={infoVisible ? "logged" : "login"}>
          <div className="container">
            © Copyright - Miejski Zakład Gospodarki Komunalnej Sp. z o.o. w Bolesławcu
          </div>
        </div>
      </footer>
    </>
  );
};

export { EkoBillingFooter };
